import validator from "../validators/validator";
import Content from "../components/ManagePrivateClassContent";
import { IWizardStep } from "../../../wizard/types";

export const editConfig: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Edit private class",
  },
  content: Content,
  validator: validator,
};
